import { Button, Card, Modal, Space, Tooltip } from 'antd';
import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import styled from 'styled-components';
import { GenerateScoreInitiativeResult } from 'components/Generator/generate-score-initiative-result-view';

const Container = styled.div`
  box-shadow: 0 4px 6px -1px rgb(113 126 195 / 10%), 0 2px 4px -2px rgb(113 126 195 / 10%);
  margin-bottom: 10px;
`;

const CardWrapper = styled.div`
  margin-bottom: 15px;
`;

interface IModalViewFile {
  isOpen: boolean;
  handleCancel: () => void;
  detail: any;
}

function ModalViewFilePgd({ isOpen, handleCancel, detail }: IModalViewFile) {
  const [selected, setSelected] = useState<any>();
  const [isCv1, setIsCv1] = useState<boolean>(false);
  const [openViewFile, setOpenViewFile] = useState<boolean>(false);

  const handleOpenFile = (record) => {
    setSelected(record);
    setOpenViewFile(true);
  };

  return (
    <Modal
      title={'PHIẾU CHẤM CỦA PHÒNG GD&ĐT'}
      centered
      visible={isOpen}
      onCancel={() => handleCancel()}
      width={800}
      maskClosable={false}
      footer={[
        <Button key="back" size="large" onClick={handleCancel}>
          Đóng
        </Button>
      ]}>
      <Container>
        <CardWrapper>
          <Card>
            <div style={{ fontWeight: 'bold' }}>Giám khảo 1</div>
            <div className="grid sm:grid-3 gap-15 sm:gap-20">
              <ul className="mt-20 flex flex-column gap-10 sm:span-2">
                {detail.certificate_cv1 !== null ? (
                  <li className="flex items-center gap-20 text-45a" style={{ cursor: 'pointer' }}>
                    <span onClick={() => {}} className="text-wrap">
                      <i className="fas fa-file mr-5"></i> Phiếu chấm giám khảo 1
                    </span>
                    <div
                      style={{ cursor: 'pointer' }}
                      className="flex items-center justify-between gap-10">
                      <Space>
                        <Tooltip title="Xem và xuất file" placement="bottomLeft">
                          <span
                            onClick={() => {
                              handleOpenFile(detail.certificate_cv1);
                              setIsCv1(true);
                            }}
                            className="detail">
                            <div className="flex items-center justify-center">
                              <i className="fas fa-eye" />
                            </div>
                          </span>
                        </Tooltip>
                      </Space>
                    </div>
                  </li>
                ) : (
                  <span>Không có file đính kèm</span>
                )}
              </ul>
            </div>
          </Card>
        </CardWrapper>
        <CardWrapper>
          <Card>
            <div style={{ fontWeight: 'bold' }}>Giám khảo 2</div>
            <div className="grid sm:grid-3 gap-15 sm:gap-20">
              <ul className="mt-20 flex flex-column gap-10 sm:span-2">
                {detail.certificate_cv2 !== null ? (
                  <li className="flex items-center gap-20 text-45a" style={{ cursor: 'pointer' }}>
                    <span onClick={() => {}} className="text-wrap">
                      <i className="fas fa-file mr-5"></i> Phiếu chấm giám khảo 2
                    </span>
                    <div
                      style={{ cursor: 'pointer' }}
                      className="flex items-center justify-between gap-10">
                      <Space>
                        <Tooltip title="Xem và xuất file" placement="bottomLeft">
                          <span
                            onClick={() => {
                              handleOpenFile(detail.certificate_cv2);
                              setIsCv1(false);
                            }}
                            className="detail">
                            <div className="flex items-center justify-center">
                              <i className="fas fa-eye" />
                            </div>
                          </span>
                        </Tooltip>
                      </Space>
                    </div>
                  </li>
                ) : (
                  <span>Không có file đính kèm</span>
                )}
              </ul>
            </div>
          </Card>
        </CardWrapper>
      </Container>
      {openViewFile && (
        <GenerateScoreInitiativeResult
          initiative={detail}
          open
          onClose={() => setOpenViewFile(false)}
          cvCertificate={selected}
          isCv1={isCv1}
        />
      )}
    </Modal>
  );
}
export default ModalViewFilePgd;
